import type { AsyncState } from '@essent/common';
import { Status } from '@essent/common';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { GetConsentGroupResponse } from '@integration/api-client/consent';

import { consentActions } from '../../api';
import { updateConsentStoreAction } from '../put-consents';

export type GetConsentsState = AsyncState<GetConsentGroupResponse[]>;

export const initialState: GetConsentsState = {
  status: Status.IDLE,
  data: undefined,
};

const _getConsentsReducer = createReducer(
  initialState,
  on(consentActions.getConsentsV1.requestAction, (state) => ({
    ...state,
    status: Status.PENDING,
  })),
  on(consentActions.getConsentsV1.successAction, (_, action) => ({
    status: Status.SUCCESS,
    data: action.payload,
  })),
  on(consentActions.getConsentsV1.errorAction, (_, action) => ({
    status: Status.ERROR,
    data: undefined,
    error: action.payload,
  })),
  on(updateConsentStoreAction, (state, action) => ({
    ...state,
    data: action.payload,
  })),
  on(consentActions.getConsentsV1.clearAction, (_) => initialState)
);

export function consentGroupReducer(
  state: GetConsentsState = initialState,
  action: Action
): GetConsentsState {
  return _getConsentsReducer(state, action);
}
